<template>
    <div class="menus-bottom flex-1 flex">   
        <div class="menus-leftside">
            <WFScrollableArea ref="sidescroll">
                <WFFilteredMenu :sortedPOIs="filteredPOIs" :currentPOI="currentPOI" v-slot:default="slotProps">
                    <div class="list-poi" @click="onPOIClick(slotProps.poi)">
                        <label class="poi-name" v-html="slotProps.poi.getName(language)"></label>
                        <div class="poi-floor" v-if="slotProps.poi.getFloor()">
                            <WFTranslate k="floor" :params="[slotProps.poi.getFloor().getName(language)]"></WFTranslate>
                            <WFIcon name="arrow"/>
                        </div>
                    </div>
                </WFFilteredMenu>
            </WFScrollableArea>
        </div>
        <div class="menus-rightside">                                    
            <WFScrollableArea class="filtered-scroll poi-list" ref="filterscroll">
                <div class="menus-rightside-content">
                    <POI v-show="currentPOI" :poi="currentPOI" @showPath="showPath" @showOnMap="showOnMap"/>
                    <div v-if="!currentPOI" class="empty-group">
                        <div class="emtpy-arrow">
                            <WFIcon name="arrow_left"></WFIcon>
                            <WFTranslate k="emptry_group">Find your interest</WFTranslate>
                        </div>
                        <WFPage :container="slug" slug="empty"/>
                    </div>
                    
                </div>
            </WFScrollableArea>
        </div>
    </div>
</template>

<script>
import POI from './POI';
import { mapState } from 'vuex';

import { WFScrollableArea, WFFilteredMenu, WFPage} from '@3dwayfinder/wayfinder-vue-components'

export default {
    name: "pois",
    components: {
        POI,
        WFScrollableArea,
        WFFilteredMenu,
        WFPage
    },
    props: {
        currentGroup: {
			type: Object,
			default: null
		},
        currentPOI: {
            type: Object,
            default: null
        }
    },
    data () {
        return {
            filteredPOIs: [],
            slug: "restaurants"
        }
    },
    computed: {
		...mapState('wf', ['language']),
    },
    watch: {
        currentGroup (n, o) {
            let oid = o ? o.id : -1;
            if (n && n.id != oid) {
                this.filterPOIs(this.currentGroup.pois);
                this.slug = this.currentGroup.slug;
            }
        }
    },
    methods: {
        filterPOIs (_pois) {
            let pois = _pois.slice();
			pois = pois.filter(p => {
				return p && p.getShowInMenu() && p.getName(this.language) !== ""
			});
            this.$store.dispatch('wf/SET_FILTERED_POIS', pois);
            if(this.$refs.sidescroll) {
                this.$refs.sidescroll.reset();
                this.$wayfinder.resize();
            }
		},
        showPath (poi) {
            this.$emit('showPath', poi);
        },
        showOnMap (poi) {
            this.$emit('showOnMap', poi);
        },
        onPOIClick (poi) {
            this.$emit('onPOIClick', poi);
        }
    }
}
</script>

<style>
    .menus-bottom .wf-page-icon {
        display: none;
    }
</style>